import { LinearProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const SteppedProgressBar = ({
  progress = 11,
  steps = 3,
  currentSlide = 0,
  message,
}) => {
  const data = {
    25: "Generating Your Personalized Exercise Plan…",
    50: "Producing High-Quality Videos…",
    75: "Merging and Combining Your Training Videos…",
  };

  const percentPerStep = 100 / steps;
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between my-3">
        <h3 className="text-[#fff] font-[600] text-[20px]">
          {t("exercisePlan.exerciseProgressLoader.loaderHeading")}
        </h3>
        <div
          className="p-3 flex items-center justify-center block md:hidden"
          style={{
            background: "linear-gradient(180deg, #0771EF 0%, #15AAFC 100%)",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
          }}
        >
          {/* <span className="!text-[11px] text-white text-sm">
            {progress.toFixed(0)}%
          </span> */}
        </div>
      </div>

      <div className="flex items-center justify-between my-3">
        <p className="text-[#fff] text-sm">
          {progress === 100
            ? "Finalizing Your Plan and Preparing for Delivery…"
            : data?.[message ?? 25]

            }
        </p>
      </div>

      <div className="flex w-full h-[22px] gap-[2px] overflow-hidden bg-white p-1 rounded-[9px]">
        {[...Array(steps)].map((_, i) => {
          const stepNumber = i + 1;
          let isFilled = false;

          // Determine which steps should be filled based on message and progress
          if (progress === 100) {
            // All steps filled when complete
            isFilled = true;
          } else if (message == 75) {
            // When messamessagege is 75, fill first and second steps
            isFilled = stepNumber <= 2;
          } else if (message == 50) {
            // When message is 50, fill only first step
            isFilled = stepNumber <= 1;
          }
          // For message 25, no steps are filled (isFilled remains false)

          return (
            <div
              key={i}
              className="h-full rounded-[9px] relative"
              style={{
                width: `${100 / steps}%`,
                backgroundColor: isFilled ? "transparent" : "#E6E6E6",
              }}
            >
              {isFilled && (
                <div
                  className="absolute top-0 left-0 h-full rounded-[9px] w-full"
                  style={{
                    background:
                      "linear-gradient(180deg, #0771EF 0%, #15AAFC 100%)",
                  }}
                ></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SteppedProgressBar;
